import React from "react";
import { Dialog as KendoDialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const Standard = (props) => {
  return (
    <KendoDialog title={props.title} onClose={props.onClose} className='flo-kendo-dialog'>
      <div style={styles.content}>
        <p style={styles.text}>
          {props.text}
        </p>
      </div>
      
      <DialogActionsBar layout="end">
        <button
          className="k-button k-primary"
          onClick={props.onConfirm}
          style={styles.modalBtn}
        >
          Ok
        </button>
        {props.enableCancelBtn &&
          <button
            className="k-button"
            onClick={props.onClose}
            style={styles.modalBtn}
          >
            Cancel
          </button>}
      </DialogActionsBar>
    </KendoDialog>
  )
}

const styles = {
  content: {
    minWidth: '275px',
  },
  text: {
    margin: '10px 10px 20px 10px',
    textAlign: 'center',
    maxWidth: '350px',
  },
  modalBtn: {
    padding: '10px 15px'
  },
}

export default Standard;